import { ListCarBrandService } from 'application/services/list-car-brand'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListCarBrand = new ListCarBrandService(api)
